// extracted by mini-css-extract-plugin
export var notificationHost = "_cx-0";